import {SouthAmericaDifficultyLevel} from "./types";

import {GAME_SOUTH_AMERICA} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as SouthAmericaMap} from "../res/south_america.svg";
import {Component} from "react";
import {Country, SOUTH_AMERICA_COUNTRIES} from "../types";

export class SouthAmericaGameFragment extends MapGameFragment<SouthAmericaDifficultyLevel> {

  protected getGame(): Game {
    return GAME_SOUTH_AMERICA;
  }

  protected allCountries(): Country[] {
    return SOUTH_AMERICA_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return SouthAmericaMap;
  }

  protected getLevels(): SouthAmericaDifficultyLevel[] {
    return SouthAmericaDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case SouthAmericaDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
    }
    return resultText;
  }
}